import { IsOptional, IsString, IsUUID } from 'class-validator'
import { Transform } from 'class-transformer'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateSubjectDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code de la matière' })
  @IsOptional()
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim())
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Libellé de la matière' })
  @IsOptional()
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim())
  label?: string

  @ApiPropertyOptional({ type: 'string', description: 'Description de la matière' })
  @IsOptional()
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim() || undefined)
  description?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID du type de matière (UUID v4)' })
  @IsOptional()
  @IsUUID('4', { message: 'Le typeId doit être un UUID v4 valide' })
  @Transform(({ value }: { value: string }) => value?.trim())
  typeId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Couleur de la matière' })
  @IsOptional()
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim()?.toUpperCase() || undefined)
  color?: string
}
